




import {Vue, Component , Prop, Watch, Emit} from 'vue-property-decorator'

@Component({})
export default class TypeAheadEditor extends Vue {
    @Prop() loader!: (params, success, failure) => any[];
    @Prop() processResults!: (data: any[]) => {results: any[]};
    @Prop({default: 250}) delay!: number;
    @Prop({default: 3}) minimumInputLength!: number;
    @Prop() value!: string;
    @Prop({default: true}) useTags;
    @Prop({default: () => []}) data!: [];
    @Prop() parent!: string;
    @Prop({default: false}) invalid!: boolean;

    $select;

    mounted() {
        this.loadSelect();
        this.$select.on('change.select2', e => {
            this.onInputChanged(this.$select.val());
        });
    }

    @Watch('value') onValueChanged(value) {
        this.$select.empty();
        this.$select.append(new Option(value, value, false, false));
        this.loadSelect();
    }

    loadSelect() {
        this.$select = $(this.$refs['select']).select2({
            width: '100%',
            tags: this.useTags,
            data: this.data,
            minimumInputLength: this.minimumInputLength,
            dropdownParent: $(this.parent || 'body'),
            containerCssClass: this.invalid ? 'invalid' : '',
            ajax: {
                transport: this.loader,
                processResults: this.processResults || this.defaultMappingFunction,
                delay: this.delay
            },
            insertTag: function (data, tag) {
                data.push(tag);
            }
        });
    }

    @Emit('input') onInputChanged(value) {}

    private defaultMappingFunction(data: any[]) {
        return {results: data.map(x => ({id: x, text: x}))};
    }

    destroyed() {
        this.$select.off().select2('destroy');
    }

}
